import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

const shimmer = keyframes`
  0% {
    opacity: 0.5;
  }
  25% {
    opacity: 0.15;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 0.15;
  }
  100% {
    opacity: 0.5;
  }
`

const Placeloader = styled.div`
  position: relative;
  animation: ${shimmer} 3s infinite cubic-bezier(0.65, 0.05, 0.36, 1);
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.12);
`

export default Placeloader
